module.exports = __webpack_public_path__ + "img/9788983924261.3f0b871e.jpg";